// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as CrownComponent} from './Crown.svg';

import Icon, { TIconProps } from '../Icon';

export const IconCrown = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <CrownComponent/>
  </Icon>
));
